import Bugsnag from "@bugsnag/js";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import BaseLayout from "src/layouts/BaseLayout";
import type { StateType } from "src/redux/reducers";
import { REQUEST_GET_WORKSPACES } from "src/redux/reducers/workspace";

const Layout = () => {
	const dispatch = useDispatch();
	const { auth } = useSelector((state: StateType) => state.user);

	useEffect(() => {
		dispatch({ type: REQUEST_GET_WORKSPACES });
	}, [dispatch]);

	useEffect(() => {
		if (import.meta.env.VITE_BUGSNAG_API_KEY && auth.authenticated && auth.checked && auth.id) {
			const name = auth.workspace?.name ? `${auth.name} (${auth.workspace.name})` : auth.name;
			Bugsnag.setUser(auth.id, auth.email, name);
		}
	}, [auth]);

	return <BaseLayout auth={auth} />;
};

export default Layout;
